(function () {
  'use strict';

  function initTestimonialGrid(section) {
    if (!section || section.dataset.testimonialInitialized === 'true') {
      return;
    }

    section.dataset.testimonialInitialized = 'true';

    const grid = section.querySelector('[data-testimonial-grid]');
    const loadMoreButton = section.querySelector('[data-load-more]');

    if (!grid) {
      return;
    }

    const cards = Array.from(
      grid.querySelectorAll('[data-testimonial-card]')
    );

    const loadCount = parseInt(
      grid.dataset.loadCount || '6',
      10
    );

    let visibleCount = cards.filter(function (card) {
      return !card.classList.contains('testimonial-card--hidden');
    }).length;

    /*
    ========================================
    LOAD MORE
    ========================================
    */

    function updateLoadMoreButton() {
      if (!loadMoreButton) {
        return;
      }

      if (visibleCount >= cards.length) {
        loadMoreButton.style.display = 'none';
      } else {
        loadMoreButton.style.display = '';
      }
    }

    function revealNextTestimonials() {
      const nextCards = cards.slice(
        visibleCount,
        visibleCount + loadCount
      );

      if (!nextCards.length) {
        updateLoadMoreButton();
        return;
      }

      nextCards.forEach(function (card, index) {
        card.classList.remove('testimonial-card--hidden');

        /*
        Small staggered animation.
        */
        card.style.animationDelay = (index * 70) + 'ms';

        requestAnimationFrame(function () {
          card.classList.add('testimonial-card--revealed');
        });
      });

      visibleCount += nextCards.length;

      updateLoadMoreButton();

      /*
      Remove animation class after animation is complete.
      */
      setTimeout(function () {
        nextCards.forEach(function (card) {
          card.classList.remove('testimonial-card--revealed');
          card.style.animationDelay = '';
        });
      }, 700);
    }

    if (loadMoreButton) {
      loadMoreButton.addEventListener(
        'click',
        revealNextTestimonials
      );
    }

    updateLoadMoreButton();

    /*
    ========================================
    VIDEO TESTIMONIALS
    ========================================
    */

    const videoCards = section.querySelectorAll(
      '.testimonial-card--video'
    );

    videoCards.forEach(function (card) {
      const video = card.querySelector('video');
      const playButton = card.querySelector('[data-video-play]');
      const poster = card.querySelector('.testimonial-video-poster');

      if (!video) {
        return;
      }

      /*
      Force required video behaviour.
      */
    //   video.muted = true;
      video.loop = true;
      video.controls = false;
      video.playsInline = true;

      /*
      ========================================
      PLAY VIDEO
      ========================================
      */

      function playVideo() {
        // video.muted = true;

        const playPromise = video.play();

        if (playPromise !== undefined) {
          playPromise
            .then(function () {
              if (playButton) {
                playButton.classList.add('is-hidden');
              }

              if (poster) {
                poster.classList.add('is-hidden');
              }
            })
            .catch(function () {
              /*
              Autoplay can be blocked by the browser.
              User can still tap the play button.
              */
            });
        }
      }

      /*
      ========================================
      PAUSE + RESET
      ========================================
      */

      function pauseAndResetVideo() {
        video.pause();

        try {
          video.currentTime = 0;
        } catch (error) {
          /*
          Ignore videos where currentTime
          is not immediately available.
          */
        }

        if (playButton) {
          playButton.classList.remove('is-hidden');
        }

        if (poster) {
          poster.classList.remove('is-hidden');
        }
      }

      /*
      ========================================
      PLAY BUTTON
      ========================================
      */

      if (playButton) {
        playButton.addEventListener(
          'click',
          function (event) {
            event.preventDefault();
            event.stopPropagation();

            if (video.paused) {
              playVideo();
            } else {
              pauseAndResetVideo();
            }
          }
        );
      }

      /*
      ========================================
      DESKTOP HOVER
      ========================================
      */

      card.addEventListener(
        'mouseenter',
        function () {
          /*
          Desktop hover play.
          */
          if (window.matchMedia('(hover: hover)').matches) {
            playVideo();
          }
        }
      );

      card.addEventListener(
        'mouseleave',
        function () {
          if (window.matchMedia('(hover: hover)').matches) {
            pauseAndResetVideo();
          }
        }
      );

      /*
      ========================================
      MOBILE TAP
      ========================================
      */

      card.addEventListener(
        'click',
        function (event) {
          /*
          Don't trigger twice if play button
          was clicked.
          */
          if (
            event.target.closest('[data-video-play]')
          ) {
            return;
          }

          if (!window.matchMedia('(hover: hover)').matches) {
            if (video.paused) {
              playVideo();
            } else {
              pauseAndResetVideo();
            }
          }
        }
      );

      /*
      ========================================
      VIDEO ENDED
      ========================================
      */

      video.addEventListener(
        'ended',
        function () {
          if (playButton) {
            playButton.classList.remove('is-hidden');
          }

          if (poster) {
            poster.classList.remove('is-hidden');
          }
        }
      );
    });
  }

  /*
  ========================================
  INITIALIZE ALL SECTIONS
  ========================================
  */

  function initAllTestimonialGrids() {
    const sections = document.querySelectorAll(
      '[id^="testimonial-grid-"]'
    );

    sections.forEach(function (section) {
      initTestimonialGrid(section);
    });
  }

  /*
  Normal page load.
  */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAllTestimonialGrids
    );
  } else {
    initAllTestimonialGrids();
  }

  /*
  Shopify Theme Editor support.
  This is important when the section is
  dynamically loaded/reloaded in Customize.
  */

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      const section = document.getElementById(
        'testimonial-grid-' + event.detail.sectionId
      );

      initTestimonialGrid(section);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    function (event) {
      const section = document.getElementById(
        'testimonial-grid-' + event.detail.sectionId
      );

      if (section) {
        section.dataset.testimonialInitialized = 'false';
      }
    }
  );
})();


